export * from './baProfilePicture.pipe';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/pipes/baProfilePicture/index.ts